import { FETCH_MONITORED_DOCUMENT_CHANGES } from '../actions/MonitoredDocumentActions';

// INITIALIZE STATE
const initialState = {
    monitoredDocumentChanges: null,
    fetching: false,
    fetched: false,
    failed: false,
    paging: {
        total: 0,
        pageNumber: 1,
        pageSize: 5,
        pages: 1,
    },
};

// REDUCER
export const MonitoredDocumentChangesReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${FETCH_MONITORED_DOCUMENT_CHANGES}_PENDING`:
            return {
                ...state,
                monitoredDocumentChanges: null,
                fetching: true,
                fetched: false,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_CHANGES}_FULFILLED`:
            return {
                ...state,
                monitoredDocumentChanges: action.payload.data,
                paging: action.payload.paging,
                fetching: false,
                fetched: true,
                failed: false,
            };
        case `${FETCH_MONITORED_DOCUMENT_CHANGES}_REJECTED`:
            return {
                ...state,
                monitoredDocumentChanges: null,
                fetching: false,
                fetched: false,
                failed: true,
            };
        default:
            return state;
    }
};
